import { z } from 'zod'

import type { SortKeyOrFunction } from './sort-key-or-function.ts'

export const PagingOptionsSchema = z.object({
  pageSize: z.number().positive().optional(),
  currentPage: z.number().positive().optional(),
  sortBy: z
    .union([
      z.string(),
      z.function({ input: [z.any(), z.any()], output: z.number() }),
    ])
    .optional(),
  sortDirection: z.enum(['asc', 'desc']).optional(),
})

export type PagingOptions<T> = {
  pageSize?: number
  currentPage?: number
  sortBy?: SortKeyOrFunction<T>
  sortDirection?: 'asc' | 'desc'
}
